package com.zq.webproject.network.model

/**
 * Author: $
 * Date: $
 * Description: $首页横幅数据类
 */
import kotlinx.serialization.Serializable

@Serializable
data class Banner(
    val title: String,
    val imageUrl: String,
    val displayOrder: Int
)

@Serializable
data class BannerResponse(
    val code: Int,
    val message:String,
    val data: List<Banner>
)